// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__nrYWN","disabled":"FileBtn_disabled__1P06M","warn":"FileBtn_warn__3BK1C","fade":"FileBtn_fade__9zcwI"};